import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {InformType} from '../../../../global/util/enum/InformType';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import {PersonService} from '../../../service/person.service';
import {AuthService} from '../../../service/auth/auth.service';
import {Constant} from '../../../../global/util/Constant';
import {StringUtil} from '../../../../global/util/StringUtil';
import {CloneTool} from '../../../../global/util/CloneTool';
import {Workflow} from '../../../model/Workflow';
import {WorkflowService} from '../../../service/workflow.service';


@Component({
  selector: 'app-assign-workflow-person',
  templateUrl: './assign-workflow-person.component.html',
  styleUrls: ['./assign-workflow-person.component.css']
})
export class AssignWorkflowPersonComponent implements OnInit {
  public authorityForm: FormGroup;
  public role: any;
  public loading: boolean;
  public selectedWorkflows: any[];
  public selectedWorkflowsDB: any[];
  public personReceived;
  public ROLE_PARTNER = Constant.ROLE_PARTNER;
  public ROLE_SUPERADMIN = Constant.ROLE_SUPERADMIN;
  public ROLE_ADMIN = Constant.ROLE_ADMIN;

  public enterpriseId: number;
  public workflows: any[] = [];

  constructor(public activeModal: NgbActiveModal,
              private personService: PersonService,
              private authenticationService: AuthService,
              private workflowService: WorkflowService,
              private formBuilder: FormBuilder) {
    this.createForm();
  }

  ngOnInit() {
    this.loadDefaultData();
  }

  public loadDefaultData() {
    if (this.hasRole(this.ROLE_SUPERADMIN) || this.hasRole(this.ROLE_PARTNER) || this.hasRole(this.ROLE_ADMIN)) {
      this.enterpriseId = this.personReceived.enterpriseIdView;
    } else {
      this.enterpriseId = LocalStorage.getEnterpriseIdView();
    }
    // this.workflows = LocalStorage.getWorkflowsBy(this.enterpriseId);
    this.getAllWorkflowBy(this.enterpriseId);
  }

  public save() {
    this.personReceived.workflows = this.getConcatSelectedWorkflows();
    this.loading = true;
    this.personService.saveWorkflows(this.personReceived).subscribe(() => {
      this.loading = false;
      this.activeModal.close(InformType.Success);
    }, () => {
      this.loading = false;
      this.activeModal.close(InformType.Danger);
    });
  }

  private getConcatSelectedWorkflows(): string {
    let value = '';
    for (const workflow of this.selectedWorkflows) {
      value += ''
        .concat(workflow.id)
        .concat(',')
        .concat(workflow.active)
        .concat('|');
    }
    return StringUtil.removeLastCharacter(value);
  }

  public cancel() {
    this.activeModal.close(-1);
  }

  public wasSelected(workflow: any): boolean {
    return this.selectedWorkflows.find(value => value.id === workflow.id && value.active === Constant.ACTIVE) !== undefined;
  }

  public wasAllSelected(): boolean {
    if (this.selectedWorkflows.length === Constant.EMPTY_LIST) {
      return false;
    }
    return !(this.workflows.find(value => !this.wasSelected(value)) !== undefined);
  }

  public addRemove(event: any, workflow: any) {
    const index = this.getIndexOf(workflow);
    if (event.target.checked) {
      if (index !== -1) {
        this.selectedWorkflows[index].active = +!this.selectedWorkflows[index].active;
      } else {
        this.selectedWorkflows.push(workflow);
      }
    } else {
      if (this.existOnDB(workflow)) {
        this.selectedWorkflows[index].active = +!this.selectedWorkflows[index].active;
      } else {
        this.selectedWorkflows.splice(index, 1);
      }
    }
  }

  private existOnDB(workflow: Workflow): boolean {
    return this.selectedWorkflowsDB.find(workflowDb => workflow.id === workflowDb.id) !== undefined;
  }

  public addOrRemoveAll(event) {
    if (event.target.checked) {
      this.selectedWorkflows = [];
      for (const workflow of this.workflows) {
        const clonedWorkFlow = CloneTool.do(workflow);
        this.selectedWorkflows.push(clonedWorkFlow);
      }
    } else {
      this.selectedWorkflows
        .filter(workflow => this.wasSelected(workflow))
        .forEach(workflow => {
          if (this.existOnDB(workflow)) {
            workflow.active = +!workflow.active;
          } else {
            this.selectedWorkflows.splice(this.getIndexOf(workflow), 1);
          }
        });
    }
  }

  private getIndexOf(workflow: any): number {
    return this.selectedWorkflows.findIndex(value => value.id === workflow.id);
  }

  private createForm() {
    this.authorityForm = this.formBuilder.group({
      workflowCheckbox: ['', [Validators.required]]
    });
  }

  getAllWorkflowBy(enterpriseId: number) {
    this.workflowService.getWorkflowsExtraBy(enterpriseId).subscribe({
      next: (workflows: Workflow[]) => {
        this.workflows = workflows.filter(workflow => (workflow.enterpriseId === enterpriseId) && workflow.ready2Use === Constant.READY_TO_USE);
      }
    });
  }

  get areThereSelectedWorkflows() {
    return this.selectedWorkflows.length !== Constant.EMPTY_LIST;
  }

  public hasRole(roleDescription: string) {
    return this.authenticationService.hasRole(roleDescription);
  }
}
